import cx from 'classnames';
import React, { ReactNode } from 'react';
import styles from './radio.module.scss';

interface RadioButtonProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  id?: string;
  label?: ReactNode;
  name?: string;
}

export const RadioButton = ({
  checked,
  onChange,
  className,
  id,
  label,
  name,
}: RadioButtonProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event.target.checked);
  };

  const uniqueId = id || `radio-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <label htmlFor={uniqueId} className={cx(styles.radioContainer, className)}>
      <input
        type="radio"
        id={uniqueId}
        name={name}
        className={styles.nativeRadio}
        checked={checked}
        onChange={handleChange}
      />
      <div className={styles.visualRadio} aria-hidden="true">
        {checked ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="8" fill="#429EFF" />
            <circle cx="8" cy="8" r="3" fill="white" />
          </svg>
        ) : (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7.5" stroke="#C4C4C4" />
          </svg>
        )}
      </div>
      {label && <span className={styles.radioLabel}>{label}</span>}
    </label>
  );
};
